<template>
  <!-- <div :class="style.fake"></div> -->
  <div :class="style.costConfiguratorForChaika">
    <section
      v-if="submit || save"
      :class="style.sendingForm + ' ' + style.active"
    >
      <button
        :class="style.buttonCross"
        @click="
          submit = false;
          save = false;
        "
      />
      <div
        @click="
          submit = false;
          save = false;
        "
        :class="style.darkeningBlurring"
      />
      <div v-if="formReceived" :class="style.content">
        <img
          src="https://readds.ru/img?name=seagull/sendingFormImg.jpg"
          alt=""
        />
        <h3>Мы получили вашу заявку</h3>
      </div>
      <div v-else :class="style.content">
        <img
          src="https://readds.ru/img?name=seagull/sendingFormImg.jpg"
          alt=""
        />
        <h3 v-text="save ? 'Сохранить расчёт' : 'Оформить заявку'"></h3>
        <p
          v-text="
            save
              ? 'Укажите вашу почту, туда придёт расчёт стоимости автодома'
              : 'Заполните поля ниже, и наш администратор перезвонит в течение 5 минут, чтобы ответить на интересующие вас вопросы.'
          "
        />
        <div v-if="!save">
          <span>Ваше имя</span>
          <input
            id="name"
            v-model="dataForm.name"
            placeholder="Иван Петров"
            type="text"
          />
        </div>
        <div>
          <span>Ваш email</span>
          <input
            id="email"
            v-model="dataForm.email"
            placeholder="info@avtorio.ru"
            type="text"
          />
        </div>
        <div v-if="!save">
          <span>Ваш телефон</span>
          <PhoneInput
            id="phone"
            v-model="dataForm.phone"
            placeholder="+7 (999) 999 99 99"
            type="text"
          />
        </div>
        <button @click="sendForm()">Отправить</button>
        <span :class="style.agreement"
          >Нажимая на кнопку, вы даете согласие на обработку персональных данных
          и соглашаетесь c политикой конфиденциальности</span
        >
      </div>
    </section>
    <Modal v-model="modalImg" :model="modalImg" :class="style.modal">
      <div :class="style.modalImg + ' ' + style[modalImg]" />
    </Modal>
    <section :class="style.leftPart">
      <h2 style="width: 100%">
        Конфигуратор стоимости индивидуального решения
      </h2>
      <Answer :data="data" :class="style.answer + ' ' + style.pc" />
      <section :class="style.informationRequest">
        <span :class="style.allCost" v-text="'Итого: ' + allCost" />
        <div :class="style.buttons">
          <button :class="style.submit" @click="submit = true">Оформить</button>
          <button :class="style.save" @click="save = true">Сохранить</button>
          <button @click="printDiv()" :class="style.printing">Печать</button>
        </div>
      </section>
    </section>
    <section :class="getClassRightPart()">
      <div v-for="(list, title) in data" :class="style.mainBlock">
        <h3 v-text="title" />
        <div :class="style.variants">
          <section
            :class="getClassSectionVariant(String(title), item)"
            v-for="(item, num) in list"
          >
            <div
              :class="getClassAdditionalBlock(item)"
              v-if="ifAdditionalBlock(item)"
            >
              <span v-if="item == 'Дополнительно'" v-text="item" />
              <span
                v-else-if="
                  item == 'Опционально' && String(title).includes('Розетка')
                "
                v-text="
                  item +
                  ' (место установки прописывается при заключении договора)'
                "
              />
              <span v-else-if="item == 'Опционально'" v-text="item" />
              <span v-else-if="item == 'Обязательно'" v-text="item" />
            </div>
            <div
              v-else-if="typeof item == 'object'"
              @click="selectVariantOne(String(title), num)"
              :class="getClassVariant(item, String(title), num)"
            >
              <div
                v-if="item.img"
                @click="modalImg = item.img"
                :class="style.img + ' ' + style[item.img]"
              />
              <div :class="style.blockInfo">
                <div :class="style.info">
                  <div>
                    <h4 v-text="item.title" />
                    <p v-if="item.subTitle" v-text="item.subTitle" />
                    <ul v-if="item.list">
                      <li v-for="li in item.list" v-text="li" />
                    </ul>
                  </div>
                  <span :class="style.cost" v-text="item.cost" />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div :class="style.unwrap">
        <button
          @click="updateUnwrap()"
          v-text="unwrap ? 'Свернуть' : 'Развернуть'"
        />
      </div>
    </section>
    <section :class="style.mobilePart">
      <h2>Ваш расчет</h2>
      <Answer :data="data" :class="style.answer" />
      <section :class="style.informationRequest">
        <span :class="style.allCost" v-text="'Итого: ' + allCost" />
        <div :class="style.buttons">
          <button :class="style.submit" @click="submit = true">Оформить</button>
          <button :class="style.save" @click="save = true">Сохранить</button>
          <button @click="printDiv()" :class="style.printing">Печать</button>
        </div>
      </section>
    </section>
  </div>
  <!-- <div :class="style.fake"></div> -->
</template>
<script lang="ts">
import {reachGoal} from "@/scripts/metrik";
import style from "./App.module.scss";
import Modal from "./modal/ModalBlock.vue";
import Answer from "./answer/Answer.vue";
import answerStyle from "./answer/Answer.module.scss";
import axios from "axios";
import $ from "jquery"; // не удалять
import PhoneInput from "./phoneInput/PhoneInput.vue";
import {defineComponent} from "vue";

window.$ = $;
export default defineComponent({
  components: {Modal, Answer, PhoneInput},
  data() {
    return {
      style,
      dataForm: {
        name: "",
        email: "",
        phone: "",
        Utm: ""
      },
      answerStyle,
      data: {
        Кузов: [
          "Обязательно",
          {
            img: "seater2Version",
            title: "2-х местный вариант",
            list: [
              "Монолитный стеклопластиковый кузов (Монокок)",
              "Светодиодные задние фонари с дополнительным стоп сигналом",
              "Габаритные светодиодные фонари",
              "Утепление пенополистирол (потолок: 50мм; пол: 60мм; боковины: 50мм)",
              "Внутренняя отделка потолка и боковин – износостойкая ткань",
              "Настил пола фанера 9мм и коммерческий линолеум",
              "Ящик-рундук для хранения (встроен в кузов прицепа)",
              "4 светодиодных светильника в потолке",
              "Светодиодный светильник на кухне с отдельным включением",
              "2 Светодиодных светильника в туалетной кабине",
              "Фонарь наружнего освещения",
              "Блок автоматов с УЗО",
              "Вводная розетка 220В"
            ],
            cost: "700 000 ₽",
            checked: true
          },
          {
            img: "seat34Option",
            title: "3-4-х местный вариант",
            list: [
              "Монолитный стеклопластиковый кузов (Монокок)",
              "Светодиодные задние фонари с дополнительным стоп сигналом",
              "Габаритные светодиодные фонари",
              "Утепление пенополистирол (потолок: 50мм; пол: 60мм; боковины: 50мм)",
              "Внутренняя отделка потолка и боковин – износостойкая ткань",
              "Настил пола фанера 9мм и коммерческий линолеум",
              "Ящик-рундук для хранения (встроен в кузов прицепа)",
              "4 светодиодных светильника в потолке",
              "Светодиодный светильник на кухне с отдельным включением",
              "2 Светодиодных светильника в туалетной кабине",
              "Фонарь наружнего освещения",
              "Блок автоматов с УЗО",
              "Вводная розетка 220В"
            ],
            cost: "700 000 ₽"
          }
        ],
        "Мебель и кухня": [
          "Обязательно",
          {
            title: "Для 2-х местного кузова",
            list: [
              "Диван-трансформер в передней части со спальным местом 2000×1900",
              "1 стол складывающейся 1600×550",
              "Шкаф для одежды",
              "Большая туалетная кабина с душевым поддоном 850×850",
              "Антресоли по периметру",
              "Холодильник 85л с морозильной камерой 12В",
              "Кухня в задней части прицепа ",
              "Мебель изготовленная по облегченной каркасной технологии с отделкой HPL пластиком",
              "Дверки с замками-фиксаторами, предотвращающие произвольное открытие"
            ],
            cost: "520 000 ₽",
            checked: true
          },
          {
            title: "Для 3-4-х местного кузова",
            list: [
              "Диван-трансформер в передней части со спальным местом 2000×1400",
              "2 места для отдыха в задней части, трансформируемые в 1 спальное место 2000×700",
              "2 стола-трансформера",
              "Шкаф для одежды",
              "Туалетная кабина с душевым поддоном",
              "Мебель изготовленная по облегченной каркасной технологии с отделкой HPL пластиком",
              "Дверки с замками-фиксаторами, предотвращающие произвольное открытие",
              "Антресоли по периметру",
              "Холодильник 85л с морозильной камерой 12В"
            ],
            cost: "520 000 ₽",
            checked: false
          },
          "Дополнительно",
          {
            title: "Мойка с стеклянной крышкой и складным краном",
            subTitle: "Вариант без газа",
            cost: "30 000 ₽",
            checked: false
          },
          {
            title: "Мойка совмещенная",
            subTitle:
              "С газовой плитой, стеклянной крышкой, складным краном, в комплекте с газовым баллоном в переднем рундуке и газовой магистралью",
            cost: "90 000 ₽",
            checked: false
          },
          "Дополнительно",
          {
            multipleOptions: true,
            title: "Дополнительное 4-е спальное место",
            subTitle: "Складной спальник второго яруса — 1980×700",
            cost: "35 000 ₽",
            checked: false
          }
        ],
        Рама: [
          "Обязательно",
          {
            title: "Стальная",
            subTitle:
              "Рама стальная 09Г2С толщиной 3мм, оцинкованная, дополнительно покрыта высокостойкой порошковой краской",
            cost: "450 000 ₽",
            checked: true
          },
          {
            title: "Из нержавеющей стали",
            subTitle: "Рама из нержавеющей стали AISI 304 толщиной 3мм",
            cost: "600 000 ₽",
            checked: false
          }
        ],
        "Тормоз и ступицы": [
          "Обязательно",
          {
            title:
              "Тормоз наката Knott со ступицами Газель, дисковыми тормозами, увеличенной грузоподъемностью",
            cost: "145 000 ₽",
            checked: true
          },
          {
            title:
              "Тормоз наката Knott со ступицами Knott, разболтовка 139.7×5",
            cost: "120 000 ₽",
            checked: false
          }
        ],
        Колеса: [
          "Обязательно",
          {
            title: "Колеса R15",
            subTitle: "Колеса с всесезонной резиной 195/70/R15C",
            cost: "45 000 ₽",
            checked: true
          },
          {
            title: "Колеса R16",
            subTitle: "Колеса с всесезонной резиной 215/65/R16С",
            cost: "60 000 ₽",
            checked: false
          }
        ],
        Подвеска: [
          "Обязательно",
          {
            title: "На пневмобаллонах с раздельной подкачкой и компрессором",
            cost: "190 000 ₽",
            checked: true
          },
          {
            title:
              "На пневмобаллонах с раздельной подкачкой и компрессором, с увеличенным ходом",
            cost: "210 000 ₽",
            checked: false
          }
        ],
        Аккумулятор: [
          "Обязательно",
          {
            title: "100 А/ч",
            subTitle: "Установка АКБ 100 А/ч Гель",
            cost: "27 000 ₽",
            checked: true
          },
          {
            title: "150 А/ч",
            subTitle: "Установка АКБ 150 А/ч LiFe",
            cost: "60 000 ₽",
            checked: false
          },
          {
            title: "205А Li Fe Po4 12v",
            subTitle: "Установка АКБ 205А Li Fe Po4 12v",
            cost: "110 000 ₽",
            checked: false
          },
          {
            title: "315А Li Fe Po4 12v",
            subTitle: "Установка АКБ 315А Li Fe Po4 12v",
            cost: "135 000 ₽",
            checked: false
          }
        ],
        "Инверторы преобразователи напряжения 12/220В": [
          "Опционально",
          {
            title: "1000 Вт 12/220В",
            subTitle: "1000 Вт 12/220В",
            cost: "22 000 ₽"
          },
          {
            title: "1700Вт 12/220В NTU 1700",
            subTitle: "1700Вт 12/220В NTU 1700",
            cost: "45 000 ₽"
          },
          {
            title: "2000Вт 12/220 Вт Mobile Comfort",
            subTitle:
              "со встроенным зарядным устройством 20А подходит для Li Fe АКБ",
            cost: "55 000 ₽"
          },
          {
            title: "3000Вт 12/220В ТВВ Power CC3/0L",
            subTitle: "подходит для  Li Fe АКБ , ток заряда до 150А",
            cost: "145 000 ₽"
          }
        ],
        "Сетевые зарядные устройства AC/DC": [
          "Опционально",
          {
            title: "12А",
            subTitle:
              "Сетевое зарядное устройство АКБ 220/12В 12А (подходит только для гелевых АКБ)",
            cost: "15 000 ₽"
          },
          {
            title: "43А",
            subTitle: "Сетевое зарядное устройство АКБ 220/12В 43А",
            cost: "25 000 ₽"
          },
          {
            title: "70А",
            subTitle: "Сетевое зарядное устройство АКБ 220/12В 70А",
            cost: "35 000 ₽"
          }
        ],
        "Зарядные устройства от автомобиля DC/DC": [
          "Опционально",
          {
            title: "20А",
            subTitle: "DC/DC Зарядное устройство АКБ 12В/12В 20А",
            cost: "20 000 ₽"
          },
          {
            title: "40А",
            subTitle: "DC/DC Зарядное устройство АКБ 12В/12В 40А",
            cost: "28 000 ₽"
          },
          {
            title: "60А",
            subTitle: "DC/DC Зарядное устройство АКБ 12В/12В 60А",
            cost: "35 000 ₽"
          }
        ],
        "Разъем прицепа": [
          "Обязательно",
          {
            title: "7 полюсный",
            subTitle: "Разъем электрический прицепа 7 полюсный",
            cost: "10 000 ₽",
            checked: true
          },
          {
            title: "13 полюсный",
            subTitle: "Разъем электрический прицепа 13 полюсный",
            cost: "15 000 ₽"
          }
        ],
        "Розетка USB": [
          "Опционально",
          {
            title: "1 шт",
            cost: "2500 ₽"
          },
          {
            title: "2 шт",
            cost: "5000 ₽"
          },
          {
            title: "3 шт",
            cost: "7500 ₽"
          },
          {
            title: "4 шт",
            cost: "10 000 ₽"
          }
        ],
        "Розетка 12В": [
          "Опционально",
          {
            title: "1 шт",
            cost: "2500 ₽"
          },
          {
            title: "2 шт",
            cost: "5000 ₽"
          },
          {
            title: "3 шт",
            cost: "7500 ₽"
          },
          {
            title: "4 шт",
            cost: "10 000 ₽"
          }
        ],
        "Розетка 220В": [
          "Опционально",
          {
            title: "1 шт",
            cost: "2500 ₽"
          },
          {
            title: "2 шт",
            cost: "5000 ₽"
          },
          {
            title: "3 шт",
            cost: "7500 ₽"
          },
          {
            title: "4 шт",
            cost: "10 000 ₽"
          }
        ],
        "Указатели уровня воды и заряда АКБ": [
          "Обязательно",
          {
            title: "Аналоговый",
            subTitle: "Указатель уровня воды и заряда АКБ аналоговый",
            cost: "15 000 ₽",
            checked: true
          },
          {
            title: "Электронный",
            subTitle: "Указатель уровня воды и заряда АКБ электронный",
            cost: "25 000 ₽",
            checked: false
          }
        ],
        "Дополнительный светильник": [
          "Опционально",
          {
            title: "4 шт",
            subTitle:
              "Дополнительный светильник на гибкой ножке со встроенной USB зарядкой",
            cost: "14 000 ₽"
          },
          {
            title: "6 шт",
            subTitle:
              "Дополнительный светильник на гибкой ножке со встроенной к-т",
            cost: "21 000 ₽"
          }
        ],
        "Солнечные панели": [
          "Опционально",
          {
            title: "200Вт",
            subTitle: "С МРРТ контроллером и табло",
            cost: "48 000 ₽"
          },
          {
            title: "400Вт",
            subTitle: "С МРРТ контроллером и табло",
            cost: "60 000 ₽"
          }
        ],
        "Переднее окно": [
          "Обязательно",
          {
            title:
              "Большое панорамное одинарное окно 900*900 в передней части со шторой",
            cost: "50 000 ₽",
            checked: true
          },
          {
            title:
              "Кемперное двойное окно 900*900 с москитной сеткой и шторкой",
            cost: "65 000 ₽"
          }
        ],
        "Боковые окна": [
          "Обязательно",
          {
            title: "2 боковых кемперных окна",
            subTitle: "900×500 с москитной сеткой и шторкой",
            cost: "90 000 ₽",
            checked: true
          },
          "Дополнительно",
          {
            multipleOptions: true,
            title: "Окно в кухонной зоне",
            subTitle: "1 кемперное окно 800×400 с москитной сеткой и шторкой",
            cost: "40 000 ₽",
            checked: false
          },
          {
            multipleOptions: true,
            title: "Окно в тулетной кабине",
            subTitle: "300×500 с москитной сеткой и шторкой",
            cost: "35 000 ₽",
            checked: false
          },
          {
            multipleOptions: true,
            title: "Окно в задней части",
            subTitle: "Внизу 700×300",
            cost: "35 000 ₽",
            checked: false
          },
          {
            multipleOptions: true,
            title: "Окно в задней части",
            subTitle: "Сверху (спальник второго яруса) 700×300",
            cost: "35 000 ₽",
            checked: false
          }
        ],
        Люки: [
          "Обязательно",
          {
            title: "Люк 400×400",
            subTitle:
              "С контурной подсветкой, оборудованный москитной сеткой и шторкой",
            cost: "35 000 ₽",
            checked: true
          },
          {
            title: "Люк 400*400 с вентилятором",
            subTitle: "Люк 400*400 с вентилятором",
            cost: "45 000 ₽",
            checked: false
          },
          {
            title: "Люк 500×700",
            subTitle: "С москитной сеткой и шторкой",
            cost: "55 000 ₽",
            checked: false
          },
          "Дополнительно",
          {
            multipleOptions: true,
            title: "Люк 280×280",
            subTitle: "В туалетной кабине, с вентилятором",
            cost: "30 000 ₽",
            checked: false
          }
        ],
        "Двери входные": [
          "Обязательно",
          {
            title:
              "С москитной сеткой, прямая, без мусорного ведра, без поручня и окна",
            cost: "65 000 ₽",
            checked: true
          },
          {
            title:
              "С москитной сеткой, окном формованной внутренней частью на алюминиевом каркасе",
            subTitle: "Производство: Россия",
            cost: "85 000 ₽",
            checked: false
          },
          {
            title:
              "С москитной сеткой, окном, формованной внутренней частью на алюминиевом каркасе",
            subTitle: "Производство: Китай. Для Европейского рынка",
            cost: "105 000 ₽",
            checked: false
          },
          {
            title:
              "C москитной сеткой, окном, формованной внутренней частью на алюминиевом каркасе, с бесключевым доступом и доводчиком",
            subTitle: "Производство: Китай. Для Европейского рынка",
            cost: "260 000 ₽",
            checked: false
          }
        ],
        "Водоснабжение и санитария": [
          "Обязательно",
          {
            title: "Бак пластиковый для чистой воды 75л",
            subTitle:
              "С водяным насосом 12 В со встроенным датчиком давления и трассой водоснабжения",
            cost: "55 000 ₽",
            checked: true
          },
          {
            title: "Бак для воды увеличенной емкости 120л",
            cost: "85 000 ₽",
            checked: false
          },
          "Обязательно",
          {
            title: "Комплект душевой (смеситель-душ)",
            cost: "60 000 ₽",
            checked: true
          },
          "Дополнительно",
          {
            multipleOptions: true,
            title: "Бак для серой воды 30л с электро клапаном слива",
            cost: "45 000 ₽",
            checked: false
          },
          {
            multipleOptions: true,
            title: "Складная раковина в туалетной кабине, с фиксацией",
            cost: "35 000 ₽",
            checked: false
          },
          {
            multipleOptions: true,
            title: "Ящики в туалетной кабине",
            cost: "9 000 ₽",
            checked: false
          }
        ],
        Туалет: [
          "Опционально",
          {
            title: "Туалет кассетный с баком",
            cost: "75 000 ₽"
          },
          {
            title: "Туалет кубик, с учетом подготовки мест крепления",
            cost: "20 000 ₽"
          }
        ],
        "Отопление и подогрев воды": [
          "Обязательно",
          {
            title: "Отопитель А-100 2кВт",
            subTitle:
              "Дизельный, комплект воздуховодов с поворотными дефлекторами, магистраль в туалетную комнату, подогрев душевого поддона, подогрев вещевого ящика, топливный бак установлен в переднем ящике-рундуке с LED экраном",
            cost: "45 000 ₽",
            checked: true
          },
          {
            title: "Отопитель А-100 5кВт",
            subTitle:
              "Дизельный, комплект воздуховодов с поворотными дефлекторами, магистраль в туалетную комнату, подогрев душевого поддона, подогрев вещевого ящика",
            cost: "55 000 ₽",
            checked: false
          },
          {
            title: "Отопитель совмещенный с бойлером Camp Life",
            subTitle:
              "Бойлер на 8 литров (аналог Трума), два встроенных в пол контура отопления, подогрев встроенных ниш, бак для воды, систему водоснабжения и воздух в салоне, возможность работы от сети 220В на стоянках",
            cost: "170 000 ₽",
            checked: false
          }
        ],
        Бойлеры: [
          "Обязательно",
          {
            title: "Бойлер для горячей воды 12В/220В",
            cost: "25 000 ₽",
            checked: true
          },
          {
            title: "Бойлер для горячей воды 12В/220В",
            subTitle: "С возможностью подогрева воды от работающего отопителя",
            cost: "45 000 ₽"
          }
        ],
        "Дополнительные опции": [
          "Опционально",
          {
            multipleOptions: true,
            title: "Штора в спальной зоне 1шт",
            cost: "9000 ₽"
          },
          {
            multipleOptions: true,
            title: "Шторы на передние окна",
            cost: "22 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Штора верхнего яруса кровати",
            cost: "9000 ₽"
          },
          {
            multipleOptions: true,
            title: "Клапан автоматического сброса воды при t ниже +4°C",
            cost: "38 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Стол наружный откидной",
            cost: "26 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Маркиза настенная 3м",
            cost: "125 000 ₽"
          },
          {
            multipleOptions: true,
            title:
              "Рейлинги в задней части с лестницей и креплением для запасного колеса",
            cost: "60 000₽"
          },
          {
            multipleOptions: true,
            title:
              "Запасное колесо с установкой в зависимости от комплектации, в задней части под днищем или на дышло прицепа",
            cost: "25 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Душевая лейка при входе",
            cost: "35 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Греющий кабель системы водоснабжения",
            cost: "25 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Люк боковой для длинномеров 700*350 1шт",
            cost: "24 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Автономный крышный кондиционер «HOUGHTON» Belair 2400",
            subTitle: "(он же «WEBASTO» TopCool) тепло/холод 220В",
            cost: "145 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Люк для подключения газового гриля",
            cost: "35 000 ₽"
          },
          {
            multipleOptions: true,
            title: "СВЧ печь (безтарелочная)",
            cost: "35 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Люк для длинномеров 700*350 2шт",
            cost: "45 000 ₽"
          },
          {
            multipleOptions: true,
            title: "Система раздачи теплого воздуха",
            subTitle:
              "От отопителя по бортам за диванами, в том числе с выходом на переднее лобовое стекло",
            cost: "60 000 ₽"
          }
        ]
      } as ConfigData,
      modalImg: "" as string,
      allCost: "0",
      save: false,
      submit: false,
      formReceived: false,
      unwrap: false
    };
  },
  mounted() {
    setTimeout(this.getCostAll, 100);
    this.scroll();
    window.addEventListener("scroll", this.scroll);
  },
  methods: {
    updateUnwrap() {
      this.unwrap = !this.unwrap;
      let url = location.href;
      location.href = "#costСonfiguratorForChaika";
      history.replaceState(null, "", url);
    },
    getClassRightPart() {
      if (this.unwrap) {
        return style.rightPart + " " + this.style.expanded;
      }
      return style.rightPart;
    },
    scroll() {
      let leftPart = document.querySelector(
        `.${this.style.leftPart}`
      ) as HTMLElement;
      let costConfiguratorForChaika = document.querySelector(
        `.${this.style.costConfiguratorForChaika}`
      );
      if (!leftPart || !costConfiguratorForChaika) {
        return;
      }
      let coordinates = costConfiguratorForChaika.getBoundingClientRect();
      let end =
        Math.abs(coordinates.top) >= coordinates.height - leftPart.clientHeight;
      if (window.innerWidth > 430) {
        if (coordinates.top <= 0 && !end) {
          leftPart.style.top = "50px";
          leftPart.style.bottom = "auto";
          leftPart.style.position = "fixed";
        } else {
          leftPart.style.top = "50px";
          leftPart.style.bottom = "auto";
          leftPart.style.position = "absolute";
        }

        if (end) {
          leftPart.style.position = "absolute";
          leftPart.style.top = "auto";
          leftPart.style.bottom = "0";
        }
      }

      if (window.innerWidth <= 430) {
        let informationRequest = leftPart.querySelector(
          `.${this.style.informationRequest}`
        );
        if (!informationRequest) {
          return;
        }
        if (
          coordinates.top > 0 ||
          coordinates.bottom <
            window.innerHeight + informationRequest.clientHeight
        ) {
          informationRequest.classList.add(this.style.hidden);
        } else {
          informationRequest.classList.remove(this.style.hidden);
        }
      }
    },
    getYMCID() {
      var match = document.cookie.match("(?:^|;)\\s*_ym_uid=([^;]*)");
      if (!match) {
        return false;
      }
      return match[1] ? decodeURIComponent(match[1]) : false;
    },
    inputError(input: HTMLInputElement) {
      if (input?.style == null) {
        return;
      }
      input.style.border = "2px solid #ffd3d3";
      setTimeout(() => {
        input.style.transition = "border 2s";
        input.style.border = "2px solid transparent";
        setTimeout(() => {
          input.style.transition = "border 0s";
          this.$nextTick(() => {
            input.style = "";
          });
        }, 1500);
      }, 10);
    },
    sendForm() {
      let email = document.querySelector("#email") as HTMLInputElement;
      let phone = document.querySelector("#phone") as HTMLInputElement;
      if (!this.dataForm.email) {
        this.inputError(email);
        return;
      }
      if (this.submit && !this.dataForm.phone) {
        this.inputError(phone);
        return;
      }
      if (!this.dataForm.email?.includes("@")) {
        this.inputError(email);
        return;
      }
      if (!this.dataForm.email?.includes(".")) {
        this.inputError(email);
        return;
      }

      if (this.submit && this.dataForm.phone.length != 12) {
        this.inputError(phone);
        return;
      }

      let answer = `\n`;
      Object.entries(this.data).forEach(([title, arr]) => {
        arr.forEach((obj) => {
          if (typeof obj != "string" && obj?.checked) {
            answer += `${title}: ${obj.title}___${obj.cost}\n`;
          }
        });
      });
      answer += `\nИтого: ${this.allCost}`;

      const search = location.search.substring(1);
      let ym_uid = this.getYMCID();
      if (search != "" || ym_uid) {
        let newParams = "";
        if (search != "") {
          const params = JSON.parse(
            '{"' +
              decodeURI(search)
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"') +
              '"}'
          );

          Object.entries(params).forEach((param) => {
            if (param[0].substring(0, 3).toLowerCase() == "utm") {
              newParams += param[0] + ": " + param[1] + "\n";
            }
          });
        }
        if (ym_uid) {
          newParams += ym_uid.replace("=", ": ") + "\n";
        }
        this.dataForm["Utm"] = newParams;
      }
      axios
        .post(
          "https://readds.ru/seagull/mail",
          {...this.dataForm, answer},
          {
            headers: {
              Accept: "application/json"
            }
          }
        )
        .then(() => {
          this.dataForm = {
            name: "",
            email: "",
            phone: "",
            Utm: ""
          };
          this.formReceived = true;
          reachGoal(97676961, "seagullSendForm");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getClassAdditionalBlock(item: string | StateObj) {
      let classItem = this.style.additionalBlock;
      if (item == "Дополнительно") {
        classItem += " " + this.style.additionally;
      }
      if (item == "Опционально") {
        classItem += " " + this.style.optional;
      }
      if (item == "Обязательно") {
        classItem += " " + this.style.necessarily;
      }
      return classItem;
    },
    ifAdditionalBlock(item: string | StateObj) {
      if (typeof item != "string") return;
      return ["Дополнительно", "Обязательно", "Опционально"].includes(item);
    },
    getClassSectionVariant(title: string, item: string | StateObj) {
      let classItem = "";
      if (typeof item == "string") {
        classItem = this.ifAdditionalBlock(item) ? style.additions : "";
      }
      if (
        typeof item !== "string" &&
        "multipleOptions" in item &&
        item.multipleOptions
      ) {
        classItem += " " + this.style.multipleOptions;
      }

      if (title?.includes("Розетка")) {
        classItem += " " + this.style["withSocket"];
      }
      return classItem;
    },
    setSpaceInNum(num: number) {
      return num?.toLocaleString("ru-RU");
    },
    printDiv() {
      var printContents = document.querySelector(
        "." + this.style.answer
      )?.innerHTML;
      let w = window.open();
      if (!w || !printContents) {
        return;
      }
      w.document.write(printContents);
      w.print();
      w.close();
    },
    getCostAll() {
      const allCost = document.querySelectorAll(
        `.${style.leftPart} .${answerStyle.cost}`
      );
      const allCostNum = Array.from(allCost).map((c) => {
        const htmlC = c as HTMLElement;
        let text = htmlC.innerText;
        let numberPattern = /\d+/g;
        if (!text) {
          return 0;
        }
        let result = text.match(numberPattern)?.join("");
        return Number(result);
      });
      const allCostNumSum = allCostNum.reduce((a, b) => {
        return a + b;
      }, 0);
      this.allCost = this.setSpaceInNum(allCostNumSum) + " ₽";
    },
    getClassVariant({img, checked}: StateObj, title: string, num: number) {
      let classItem = this.style["variant"];
      if (img) {
        classItem += " " + this.style["existImg"];
      }
      if (checked) {
        classItem += " " + this.style["active"];
      }
      if (
        typeof this.data["Кузов"][1] != "string" &&
        title == "Мебель и кухня" &&
        num == 7 &&
        this.data["Кузов"][1].checked
      ) {
        classItem += " " + this.style["notСhoose"];
      }

      if (
        typeof this.data["Отопление и подогрев воды"][3] != "string" &&
        title == "Бойлеры" &&
        (num == 1 || num == 2) &&
        this.data["Отопление и подогрев воды"][3].checked
      ) {
        classItem += " " + this.style["notСhoose"];
      }

      return classItem;
    },
    selectVariantOne(title: string, num: number, auto = false) {
      if (
        this.getClassVariant({title: "", cost: ""}, title, num).includes(
          "notСhoose"
        )
      ) {
        return;
      }
      let minSectionNum = num;
      let maxSectionNum = num;
      while (typeof this.data[title][minSectionNum] == "object") {
        minSectionNum--;
      }
      while (
        typeof this.data[title][maxSectionNum] == "object" &&
        typeof this.data[title][maxSectionNum] != "undefined"
      ) {
        maxSectionNum++;
      }

      if (
        typeof this.data[title][num] != "string" &&
        this.data[title][num]?.multipleOptions != null
      ) {
        this.data[title][num].checked = !this.data[title][num].checked;
        return;
      }
      if (
        this.data[title][0] == "Дополнительно" ||
        this.data[title][0] == "Опционально"
      ) {
        this.data[title] = this.data[title].map((t, n) => {
          if (typeof t === "string") return t;
          if (
            n != 0 &&
            (typeof t?.checked == "boolean" || typeof t?.checked == "undefined")
          ) {
            t.checked = n == num ? !t.checked : false;
          }
          return t;
        });
        return;
      } else {
        this.data[title] = this.data[title].map((t, n) => {
          if (typeof t === "string") return t;
          if (
            n > minSectionNum &&
            n < maxSectionNum &&
            t?.checked &&
            !t?.multipleOptions &&
            "checked" in t
          ) {
            t.checked = false;
          }
          return t;
        });
      }
      if (this.data[title][num] == null) {
        return;
      }
      if (typeof this.data[title][num] == "string") {
        return;
      }
      this.data[title][num].checked = true;
      if (!auto) {
        this.autoSelect(title, num);
      }
    },
    autoSelect(title: string, num: number) {
      if (title == "Кузов") {
        this.selectVariantOne("Мебель и кухня", num, true);
      }
      if (title == "Мебель и кухня") {
        this.selectVariantOne("Кузов", num, true);
      }

      if (
        typeof this.data["Мебель и кухня"][7] != "string" &&
        num == 1 &&
        (title == "Кузов" || title == "Мебель и кухня")
      ) {
        this.data["Мебель и кухня"][7].checked = false;
      }

      if (
        typeof this.data["Бойлеры"][1] != "string" &&
        typeof this.data["Бойлеры"][2] != "string" &&
        title == "Отопление и подогрев воды" &&
        num == 3
      ) {
        this.data["Бойлеры"][1].checked = false;
        this.data["Бойлеры"][2].checked = false;
      }
      if (
        typeof this.data["Бойлеры"][1] != "string" &&
        typeof this.data["Бойлеры"][2] != "string" &&
        title == "Отопление и подогрев воды" &&
        num != 3 &&
        !this.data["Бойлеры"][1].checked &&
        !this.data["Бойлеры"][2].checked
      ) {
        this.data["Бойлеры"][1].checked = true;
      }
    }
  },
  computed: {
    strData() {
      return JSON.stringify(this.data);
    }
  },
  watch: {
    unwrap(data) {
      if (!data) {
        let rightPart = document.querySelector("." + this.style.rightPart);
        if (rightPart) rightPart.scrollTo({top: 0, behavior: "smooth"});
      }
    },
    save(data) {
      if (data) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
        this.formReceived = false;
      }
    },
    submit(data) {
      if (data) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
        this.formReceived = false;
      }
    },
    strData() {
      setTimeout(this.getCostAll, 100);
    }
  }
});
</script>
